import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useContext } from "react";
import { dateFormatOptionsWithTimeZone } from "../utils";
import { formatWithTimeZone } from "../../core";
export const TimeZoneContext = /*#__PURE__*/ createContext(undefined);
export function TimeZoneProvider(props) {
    const { children, timeZone } = props;
    return /*#__PURE__*/ _jsx(TimeZoneContext.Provider, {
        value: timeZone,
        children: children
    });
}
export function useTimeZone() {
    const timeZone = useContext(TimeZoneContext);
    return {
        // fallback to "local" timezone if TimeZoneProvider is not present in the React tree
        timeZone: timeZone ?? 'local',
        formatWithUserTimeZone (date, formatString) {
            return formatWithTimeZone(date, formatString, timeZone);
        },
        dateFormatOptionsWithUserTimeZone (dateFormatOptions) {
            return dateFormatOptionsWithTimeZone(dateFormatOptions, timeZone);
        }
    };
}

//# sourceMappingURL=TimeZoneProvider.js.map